module.exports = __webpack_public_path__ + "img/stevejobs.7c861270.png";